import * as THREE from 'three'

export default class GridLayer
{
    constructor(scene) 
    {
        this.scene = scene

        this.createLayer()
    }

    createLayer() 

    {
        const gridSide = this.scene.STside
        const gridSquaresPerSide = this.scene.GRIDsize
        const gridYPosition = this.scene.GRIDposition - 0.001
        const gridOpacity = 0.15
        const gridLineWidth = 0.0025

        this.material = new THREE.LineBasicMaterial({
            transparent: true,
            opacity: 0.3,
            blending: THREE.NormalBlending,
            depthWrite: false
        })


        //draw Z lines
        for (let i = 0; i < gridSquaresPerSide + 1; i++) {
            const lineDelta = gridSide / gridSquaresPerSide
            const lineGeom = new THREE.PlaneGeometry(gridSide, gridLineWidth)
            const lineMat = new THREE.LineBasicMaterial()
            lineMat.copy(this.material)
            lineMat.opacity = gridOpacity
            const line = new THREE.Mesh(lineGeom, lineMat)
            this.scene.add(line)
            line.rotateX(-Math.PI/2)
            line.position.set(0, gridYPosition , gridSide / 2 - i * lineDelta)
        }

        //draw X lines
        for (let i = 0; i < gridSquaresPerSide + 1; i++) {
            const lineDelta = gridSide / gridSquaresPerSide
            const lineGeom = new THREE.PlaneGeometry(gridLineWidth, gridSide)
            const lineMat = new THREE.LineBasicMaterial()
            lineMat.copy(this.material)
            lineMat.opacity = gridOpacity
            const line = new THREE.Mesh(lineGeom, lineMat)
            this.scene.add(line)
            line.rotateX(-Math.PI/2)
            line.position.set(-gridSide / 2 + i * lineDelta, gridYPosition ,0)
        }
    }

    showNavigationText(node) {
        if (this.navigationText) this.scene.remove(this.navigationText)
        
        //create image
        var bitmap = document.createElement('canvas');
        var g = bitmap.getContext('2d');
        bitmap.width = 512;
        bitmap.height = 256;
        g.font = '22px Inter';
        g.fillStyle = 'white';
        let textString = null
        if (!node) textString = "data sources"
        else {
            textString = "NETWORK — " + node.data.name
        }
        
        textString = textString.toUpperCase()
        // Letter Spacing Fix
        var ctext = (textString).split("").join(String.fromCharCode(8202) + String.fromCharCode(8202) + String.fromCharCode(8202))
        g.fillText(ctext, 0, 20);

        // canvas contents will be used for a texture
        var texture = new THREE.Texture(bitmap) 
        texture.needsUpdate = true;

        const spriteGeometry = new THREE.PlaneBufferGeometry(0.5, 0.23, 1)
        const spriteMaterial = new THREE.MeshBasicMaterial( { map: texture } );
        spriteMaterial.transparent = true
        spriteMaterial.depthWrite = false

        const textDeltaFromReferenceSize = (this.scene.STside-1)*0.5
        this.navigationText = new THREE.Mesh( spriteGeometry, spriteMaterial );
        this.scene.add( this.navigationText );
        this.navigationText.translateZ(0.63 + textDeltaFromReferenceSize)
        this.navigationText.translateY(this.scene.GRIDposition)
        this.navigationText.translateX(-0.25 - textDeltaFromReferenceSize)
        this.navigationText.rotateX(-Math.PI*0.5)
    }


    hideNavigationText() {
        if (this.navigationText) this.navigationText.visible = false
    }

    showBackText() {
        if (this.backText) this.backText.visible = true
        else {
            //create image 
            var bitmap = document.createElement('canvas');
            var g = bitmap.getContext('2d');
            bitmap.width = 512;
            bitmap.height = 256;
            g.font = '22px Inter';
            g.fillStyle = 'white';
            // Letter Spacing Fix
            var ctext = ("BACK TO DATA SOURCES").split("").join(String.fromCharCode(8202) + String.fromCharCode(8202) + String.fromCharCode(8202))
            g.fillText(ctext, 0, 20);

            

            // canvas contents will be used for a texture
            let texture = new THREE.Texture(bitmap) 
            texture.needsUpdate = true;

            const spriteGeometry = new THREE.PlaneBufferGeometry(0.5, 0.23, 1)
            const spriteMaterial = new THREE.MeshBasicMaterial( { map: texture } );
            spriteMaterial.transparent = true
            spriteMaterial.depthWrite = false

            this.backText = new THREE.Mesh( spriteGeometry, spriteMaterial );
            this.scene.add( this.backText );
            const textDeltaFromReferenceSize = (this.scene.STside-1)*0.5
            this.backText.translateZ(-0.42 - textDeltaFromReferenceSize)
            this.backText.translateY(this.scene.GRIDposition)
            this.backText.translateX(-0.187 - textDeltaFromReferenceSize)
            this.backText.rotateX(-Math.PI*0.5)

            const textureLoader = new THREE.TextureLoader()
            const arrowSvg = textureLoader.load('./textures/arrow-left.svg')
            const arrowGeometry = new THREE.PlaneBufferGeometry(0.073 * 0.52, 0.038 * 0.52,1)
            const arrowMaterial = new THREE.MeshBasicMaterial( { map: arrowSvg } );
            arrowMaterial.transparent = true
    
            const arrowSprite = new THREE.Mesh( arrowGeometry, arrowMaterial );
            this.backText.add( arrowSprite );
            arrowSprite.translateY(0.105)
            arrowSprite.translateX(-0.295)
        }
    }

    hideBackText() {
        if (this.backText) this.backText.visible = false
    }
}